import React, { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setPinNeeded } from 'store/cast/actions';
import { selectCastPinNeeded, selectItemToCast } from 'store/cast/selectors';
import { selectAppState } from 'store/config/selectors';
import { setCashedPin } from 'store/user/actions';
import { selectActiveUserProfile } from 'store/user/selectors';

import { EventParentalControlRating } from 'services/data-manager/types';

import { useCast } from 'utils/cast/useCast';

import GenericPinDialog from 'components/GenericPinDialog';

function CastPinDialog() {
    const { loadMedia } = useCast();
    const dispatch = useDispatch();
    const appState = useSelector(selectAppState);
    const pinNeeded = useSelector(selectCastPinNeeded);
    const assetToCast = useSelector(selectItemToCast);
    const selectedProfileId = useSelector(selectActiveUserProfile);

    const handleClose = useCallback(() => {
        dispatch(setPinNeeded(false));
    }, []);

    const updateCashedPinsTimestamp = useCallback(
        (parentalRating?: EventParentalControlRating) => {
            const hasParentalRating =
                parentalRating && !parentalRating.includes('adult');

            if (hasParentalRating && selectedProfileId) {
                const timestamp = Date.now();

                dispatch(
                    setCashedPin(selectedProfileId, parentalRating, timestamp),
                );
            }
        },
        [selectedProfileId],
    );

    const handleSuccess = useCallback(() => {
        if (assetToCast.videoItem && assetToCast.playbackType) {
            updateCashedPinsTimestamp(assetToCast.videoItem?.parentalRating);
            loadMedia(assetToCast.videoItem, assetToCast.playbackType);
        }
        dispatch(setPinNeeded(false));
    }, [loadMedia, assetToCast]);

    return (
        <GenericPinDialog
            modal
            appState={appState}
            visible={pinNeeded}
            onClose={handleClose}
            onSuccess={handleSuccess}
        />
    );
}

export default CastPinDialog;
